export default __webpack_public_path__ + "static/swim-f5a375573d53358378d618a649cbcb82.jpg";